module.exports = __webpack_public_path__ + "img/con3_return_visit1.82606770.png";